module.exports = __webpack_public_path__ + "static/media/ico_compo_noborder.80a035e7.svg";